import {
  resideoProMybusinessDashboardLink,
  resideoProMybusinessCustomersLink,
  resideoProMybusinessCompanyLink,
} from 'config/externalLinks';

/*
    This UI is mounted at the path /mybusiness/services-subscriptions
    in Pro-Portal, the /mybusiness path has the secondary navigation links
    but this UI does not have a special route to contain the link data.
    For that reason, we have created the link data as a seaparate file
*/
export const subNavLinks = () => [
  {
    name: 'dashboard',
    external: true,
    path: resideoProMybusinessDashboardLink,
    textKey: 'header.secondary.dashboard',
  },
  {
    external: true,
    name: 'customers',
    path: resideoProMybusinessCustomersLink,
    textKey: 'header.secondary.customerAccounts',
  },
  {
    name: 'subscriptions',
    external: false,
    path: '/',
    textKey: 'header.secondary.servicesSubscriptions',
  },
  {
    name: 'company',
    external: true,
    path: resideoProMybusinessCompanyLink,
    textKey: 'header.secondary.companyInfo',
  },
];
